import { render, staticRenderFns } from "./AssistantServiceOptions.vue?vue&type=template&id=0c7f1a7c"
import script from "./AssistantServiceOptions.vue?vue&type=script&lang=js"
export * from "./AssistantServiceOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports